//@TODO: needs refactoring to follow right practices
angular.module('jv.cand.resume.model.factory',[])
    .factory('jvCandResumeModelFactory', ['$http', 'candidates', function($http, candidates){
        return function(scope, destkey){
            var resumeModel  = window.JV.JH.Model.create();
            resumeModel.scope = scope;
            resumeModel.destkey = destkey;
            resumeModel.xhr = $http;
            resumeModel.saveUploadContent = function(resourceInfo){
                var data = resourceInfo,
                    uploadParams = {},
                    fileIds;

                if(data.fId) {
                    fileIds = angular.isArray(data.fId) ? data.fId.join() : data.fId;
                    uploadParams = {
                        applicationId: data.applicationId,
                        fId: fileIds,
                        fileKind: data.kind
                    };
                }
                else{
                    uploadParams = {
                        applicationId: data.applicationId,
                        fileKind: data.kind
                    };
                }
                /*TODO: fileIds will be passed as undefined when FE sends request to save PastedResume.
                * agreed by BE. BE might change this later.
                */
               candidates.saveUploadContent(
                 data,
                 fileIds,
                 uploadParams,
                 function() {
                   scope.file.showUploadPanel = false;
                   scope.errors = {};
                   var type = scope.file.fileKind.toLowerCase();
                   scope[type] = {};
                   scope.resourceInfo = {};
                   if (scope.file.fileKind === 'Attachment') {
                     scope.jumpTo(scope.file.fileKind, 0);
                     scope.response.eids = [];
                   } else {
                     scope.jumpTo(scope.file.fileKind);
                   }
                   scope.textarea = {};
                   scope[scope.file.fileKind].Uploader = false;
                 },
                 function(error){
                    if(error.status == 417){
                        scope.errors.pasteUpload = i18n.I18N_MALICIOUS_CONTENT;
                    }else{
                        scope.errors.pasteUpload = i18n.I18N_FILE_UPLOAD_ERROR;
                    }
                    scope.textarea = {};
                 });
            };
            resumeModel.fetchClickedAttachment = function(appId, fileId){
                var inList = false;
                if(scope.attachmentList.length > 0){
                    for(var i=0 ; i < scope.attachmentList.length ; i++){
                        if(scope.attachmentList[i] && scope.attachmentList[i].eid === fileId){
                            inList = true;
                            scope.file = scope.attachmentList[i];
                            scope.file.fileKind = 'Attachment';
                            scope.file.fileType = i18n.ATTACHMENT;
                            scope.file.kind = 'Portfolio';
                        }
                    }
                }
                if(!inList){
                    candidates.fetchClickedAttachment(appId, fileId, function(response, status){
                        if(status === 200){
                            scope.attachmentList.push(response.resourceInfo);
                            scope.file = response.resourceInfo;
                            delete scope.file.fileKind;
                            scope.file.fileKind = 'Attachment';
                            scope.file.fileType = i18n.ATTACHMENT;
                            scope.file.kind = 'Portfolio';
                        }
                    });
                }
            };
            resumeModel.header = function(applicationId) {
                $http.post('../../action/applicationDetails?applicationId='+applicationId).success(function(response){
                    scope.header = response;
                });
            };
            return resumeModel;
        };
    }]);